/**
 * Where the shared sign-in / team steps live and where they lead.
 *
 * The auth gate, team picker and team create pages serve two flows:
 *   - single event:  /events/:eventId/{auth,teams,team-create} → confirm
 *   - bulk:          /bulk/{auth,teams,team-create}            → choose events
 * Pages build their links from this instead of hardcoding /events/:eventId.
 */
import { useLocation, useParams } from 'react-router-dom';

export function useFlowBase() {
  const { eventId } = useParams<{ eventId: string }>();
  const { pathname } = useLocation();
  const isBulk = pathname === '/bulk' || pathname.startsWith('/bulk/');
  const base = isBulk ? '/bulk' : `/events/${eventId}`;
  return {
    isBulk,
    eventId: isBulk ? undefined : eventId,
    base,
    /** Next step once a team is chosen or created. */
    afterTeam: isBulk ? '/bulk/events' : `/events/${eventId}/confirm`,
  };
}
